import "./UsersTable.css";
import styles from "./UsersTable.module.css";
import { Checkbox } from "@mui/material";
import Icon from "@mdi/react";
import { mdiPencil, mdiDelete } from "@mdi/js";

// react
import React, { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTable, useSortBy } from "react-table";

// components
import ConfirmDialog from "components/ConfirmDialog";

export default function UsersTable({ users, handleDelete }) {
	const [openDialog, setOpendialog] = useState(false);
	const [openDialogId, setOpendialogId] = useState(-1);
	const data = useMemo(() => users, [users]);
	const columns = useMemo(
		() => [
			{
				Header: "Username",
				accessor: "userName",
			},
			{
				Header: "Weight",
				accessor: "weight",
			},
			{
				Header: "Active",
				accessor: "active",
				Cell: ({ cell }) => <Checkbox disabled checked={cell.value} />,
				sortType: "basic",
			},
			{
				Header: "Roles",
				accessor: "roles",
			},
			{
				Header: "Edit",
				accessor: "edit",
				Cell: ({ cell }) => (
					<NavLink to={{ pathname: `/users/${cell.row.original.id}` }}>
						<Icon path={mdiPencil} size={1} color="grey" style={{ cursor: "pointer" }} />
					</NavLink>
				),
			},
			{
				Header: "Delete",
				accessor: "delete",
				Cell: ({ cell }) => (
					<Icon
						path={mdiDelete}
						size={1}
						color="grey"
						style={{ cursor: "pointer" }}
						onClick={() => {
							setOpendialog(true);
							setOpendialogId(cell.row.original.id);
						}}
					/>
				),
			},
		],
		[handleDelete]
	);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

	//handle
	const deleteWithDialog = (reason) => {
		if (reason == "yes") handleDelete(openDialogId);
		setOpendialog(false);
	};

	return (
		<div className={styles.container}>
			<ConfirmDialog open={openDialog} title={"Attention"} yes no onClose={deleteWithDialog}>
				{"Are you sure you want to delete this user?"}
			</ConfirmDialog>
			<table {...getTableProps()}>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps(column.getSortByToggleProps())}>
									{column.render("Header")}
									<span>{column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}</span>
								</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}
